<p-dialog
  header="System Settings"
  [(visible)]="showSystemSettingsDialog"
  [modal]="true"
  [closable]="true"
  (onHide)="onDialogHide()"
  [style]="{ width: '450px' }"
  (onShow)="onDialogShow()"
>
  <!-- Example Subsection: AI Summary Assistant -->
  <h3>AI Summary Assistant</h3>
  <p-select
    [options]="aiAssistantOptions"
    [(ngModel)]="selectedAiAssistant"
    placeholder="Select Summary AI Assistant"
    optionLabel="label"
    styleClass="w-full"
    appendTo="body"
  ></p-select>

  <h3>Developer Mode</h3>
  <p-select
    [options]="developerModeOptions"
    [(ngModel)]="selectedDeveloperMode"
    placeholder="Select Developer Mode"
    optionLabel="label"
    styleClass="w-full"
    appendTo="body"
  ></p-select>

  <h3>Local Storage / Personalization</h3>
  <div class="flex align-items-center gap-2 mb-3">
    <p-toggleswitch
      [(ngModel)]="showWelcomeDialogLocalStorage"
    ></p-toggleswitch>
    <label for="showWelcomeDialogLocalStorage">Show Welcome Dialog</label>
  </div>

  <div class="flex gap-2 mt-4 justify-content-end">
    <button
      pButton
      label="Close"
      icon="pi pi-times"
      (click)="closeDialog()"
    ></button>
    <button
      pButton
      label="Save"
      icon="pi pi-times"
      (click)="saveAndClose()"
    ></button>
  </div>
</p-dialog>
